import RejectDepositForm from './RejectDepositForm';

export default RejectDepositForm;
